import React from 'react';
import Notification from './Notification';
const NotificationS = ({ color, ...props }) => (React.createElement(Notification, Object.assign({ color: color, size: 24 }, props)));
NotificationS.displayName = 'NotificationS'; // Fix for tsc
export default NotificationS;
//# sourceMappingURL=NotificationS.js.map